/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/InvalidateAction/Content/Content/ConfirmAction"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 onClick={onClick}
 marginRight={dtSpaceXs}
 text="Disable"
 type="critical"
/>
{children}
</React.Fragment>)
}